import {useHistory} from 'react-router-dom';

import Typography from 'components/Typography';
import Modal from 'components/Modal';
import Button from 'components/Button';
import Avatar from 'components/Avatar';

import {getFullName} from 'helpers/user';
import useAuth from 'hooks/useAuth';

import sidebarStyles from '../Sidebar.module.scss';
import styles from './UserModal.module.scss';
import {get} from 'lodash';
import {phoneFormat} from 'helpers/phoneFormat';
import FormActionGroup from 'components/FormActionGroup';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

function UserModal({isOpen, onClose}: Props) {
  const {currentUser, logout} = useAuth();
  const {push} = useHistory();

  function updateHandler() {
    onClose();
    if (get(currentUser, 'role') === 'prescriber') {
      push('/prescriber/settings');
    } else {
      push('/account');
    }
  }

  return (
    <Modal className={styles.modal} isOpen={isOpen} onClose={onClose}>
      <Typography variant="h2">Profile</Typography>

      <div className={styles.root}>
        <Avatar
          className={sidebarStyles.user__avatar}
          file={currentUser?.avatar}
        />
        <Typography className={styles.email} component="p" variant="h3">
          {getFullName(currentUser)}
        </Typography>
      </div>
      <div className={styles.details}>
        <div className={styles.label}>
          <Typography variant="label">Account details</Typography>
        </div>
        <div className={styles.detail}>
          <Typography component="p">Email:</Typography>
          <Typography className={styles.email} component="p">
            {currentUser?.email}
          </Typography>
        </div>
        <br />
        <div className={styles.detail}>
          <Typography component="p">Phone:</Typography>
          <Typography className={styles.email} component="p">
            {phoneFormat(currentUser?.phone || '')}
          </Typography>
        </div>
      </div>
      <FormActionGroup className={styles.actionGroup}>
        <Button color="danger" onClick={logout}>
          Logout
        </Button>
        <Button onClick={updateHandler}>Edit details</Button>
      </FormActionGroup>
    </Modal>
  );
}

export default UserModal;
